module.exports = __webpack_public_path__ + "static/suttora-df7d2daba60249ecda37034116b1cc77.jpg";